import { Megaphone, TrendingUp, ShoppingCart, Headphones } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { LucideIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const agentKeys = ['marketing', 'sales', 'commerce', 'service'];
const agentIcons: LucideIcon[] = [Megaphone, TrendingUp, ShoppingCart, Headphones];
const agentIconColors = ["text-chathero-mint", "text-chathero-orange", "text-chathero-orange", "text-chathero-mint"];
const agentIconBgs = ["bg-chathero-mint/20 border-chathero-mint/50", "bg-chathero-orange/20 border-chathero-orange/50", "bg-chathero-orange/20 border-chathero-orange/50", "bg-chathero-mint/20 border-chathero-mint/50"];

const AgentsSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="agents" className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t('agents.tag')}</Badge>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
            {t('agents.title')}
          </h2>
          <p className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            {t('agents.titleLine2')}
          </p>
          <p className="text-lg text-chathero-orange font-semibold max-w-2xl mx-auto">
            {t('agents.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {agentKeys.map((key, index) => {
            const Icon = agentIcons[index];
            return (
              <div
                key={key}
                className="bg-white rounded-2xl p-6 border border-border shadow-[0_4px_24px_rgba(0,196,180,0.08)] hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(0,196,180,0.14)] transition-all duration-300 group"
              >
                <div className="flex items-start gap-5">
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 border-2 ${agentIconBgs[index]} group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className={`w-8 h-8 ${agentIconColors[index]}`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-primary mb-3">
                      {t(`agents.items.${key}.name`)}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {t(`agents.items.${key}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AgentsSection;
